import React, { useState, useEffect } from 'react';
import "./TasksPage.css";
import { useAuth } from '../auth/Auth';

function TasksPage() {
  const { user } = useAuth();
  const [webhooks, setWebhooks] = useState([]);
  const [archivedTasks, setArchivedTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [reversedTimers, setReversedTimers] = useState({});
  const [isGeneralPoolCollapsed, setIsGeneralPoolCollapsed] = useState(false);
  const [isPersonalPoolCollapsed, setIsPersonalPoolCollapsed] = useState(false);
  const [statusTimers, setStatusTimers] = useState({});
  const [theme, setTheme] = useState('white');

  const userId = user?.user_id || localStorage.getItem('userId') || '271';


  const fetchThemeConfig = async () => {
    try {
      const response = await fetch(`https://hub2.daolog.net/user-theme-config/${userId}`);
      if (response.ok) {
        const config = await response.json();
        setTheme(config.theme || 'white');
      } else {
        setTheme('white');
      }
    } catch (error) {
      console.error('Error fetching theme config:', error);
      setTheme('white');
    }
  };

  const updateThemeConfig = async (newTheme) => {
    try {
      const response = await fetch(`https://hub2.daolog.net/update-user-theme-config/${userId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ theme: newTheme })
      });
      
      if (response.ok) {
        const data = await response.json();
        setTheme(data.theme);
      }
    } catch (error) {
      console.error('Error updating theme config:', error);
    }
  };

  useEffect(() => {
    if (user?.user_id) {
      localStorage.setItem('userId', user.user_id);
    }
  }, [user?.user_id]);

  useEffect(() => {
    fetchThemeConfig();
  }, [userId]);

  const handlePipToggle = () => {
    if (window.__interactiveTabPiP && window.__interactiveTabPiP.toggle) {
      window.__interactiveTabPiP.toggle({
        mode: 'element-only',
        targetSelector: '.pip-target-element' 
      });
    } else {
      alert('Для використання цієї функції необхідно встановити розширення "Interactive Tab PiP".');
    }
  };

 
  const toggleTheme = () => {
    const newTheme = theme === 'white' ? 'dark' : 'white';
    updateThemeConfig(newTheme);
  };

  const toggleTimerDirection = (taskLink) => {
    setReversedTimers(prev => ({
      ...prev,
      [taskLink]: !prev[taskLink]
    }));
  };


  const calculateTimeInStatus = (receivedAt) => {
    if (!receivedAt) return null;
    
    const statusTime = new Date(receivedAt);
    const now = new Date();
    const timeInStatus = now - statusTime;
    
    const totalSeconds = Math.floor(timeInStatus / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    return {
      hours: hours.toString().padStart(2, '0'),
      minutes: minutes.toString().padStart(2, '0'),
      seconds: seconds.toString().padStart(2, '0'),
      text: `${hours > 0 ? `${hours}:` : ''}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
      totalTimeInMs: timeInStatus
    };
  };

  const calculateEndTime = (receivedAt, taskTimer) => {
    if (!taskTimer) return null;
    
    const startTime = new Date(receivedAt);
    const timerMatch = taskTimer.match(/(\d+)\s*(хв|год)/);
    
    if (!timerMatch) return null;
    
    const value = parseInt(timerMatch[1]);
    const unit = timerMatch[2];
    
    if (unit === 'хв') {
      startTime.setMinutes(startTime.getMinutes() + value);
    } else if (unit === 'год') {
      startTime.setHours(startTime.getHours() + value);
    }
    
    return startTime;
  };

  const calculateTimeLeft = (endTime, receivedAt) => {
    const now = new Date();
    const difference = endTime - now;
    
    if (difference <= 0) {
      return { 
        expired: true, 
        text: '', 
        percentage: 100,
        endTime: endTime
      };
    }
    
    const hours = Math.floor(difference / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);
    
    const totalTime = endTime - new Date(receivedAt);
    const percentage = totalTime > 0 ? 100 - (difference / totalTime * 100) : 0;
    
    return {
      expired: false,
      hours: hours.toString().padStart(2, '0'),
      minutes: minutes.toString().padStart(2, '0'),
      seconds: seconds.toString().padStart(2, '0'),
      text: `${hours > 0 ? `${hours}:` : ''}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
      percentage: Math.min(Math.max(percentage, 0), 100),
      endTime: endTime
    };
  };

  const calculateGeneralPoolTime = (startdate) => {
    if (!startdate) return null;
    
    const startTime = new Date(startdate.replace(', ', 'T'));
    const now = new Date();
    const timeInPool = now - startTime; 
    
    const tenMinutesInMs = 10 * 60 * 1000;
    if (timeInPool <= tenMinutesInMs) {
      return null; 
    }
    
    const totalSeconds = Math.floor(timeInPool / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    
    return {
      hours: hours.toString().padStart(2, '0'),
      minutes: minutes.toString().padStart(2, '0'),
      seconds: seconds.toString().padStart(2, '0'),
      text: `${hours > 0 ? `${hours}:` : ''}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
      totalTimeInMs: timeInPool
    };
  };

  const formatStartDate = (startdate) => {
    if (!startdate) return '';
    const date = new Date(startdate.replace(', ', 'T'));
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const formatEndTime = (endTime) => {
    if (!endTime) return '';
    const hours = endTime.getHours().toString().padStart(2, '0');
    const minutes = endTime.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const getArchivedTaskLinks = () => {
    return archivedTasks.map(task => task.TaskLink || task.taskLink);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!userId) {
        setLoading(false);
        return;
      }

      try {
        setError('');
        
    
        const tokenResponse = await fetch(`https://hub2.daolog.net/api/user-token/${userId}`);
        
        if (!tokenResponse.ok) {
          throw new Error(`Помилка отримання токену: ${tokenResponse.status}`);
        }
        
        const tokenData = await tokenResponse.json();
        const userToken = tokenData.token;
        
        if (!userToken) {
          throw new Error('Токен користувача не знайдено');
        }
  
    
        const [webhooksResponse, archiveResponse] = await Promise.all([
          fetch(`https://hub2.daolog.net/api/pf-webhooks-by-token/${userToken}`),
          fetch(`https://hub2.daolog.net/api/archived-tasks`)
        ]);
        
        if (!webhooksResponse.ok) {
          throw new Error(`Помилка отримання вебхуків: ${webhooksResponse.status}`);
        }
        
        const webhooksData = await webhooksResponse.json();
        const archiveData = await archiveResponse.json();
        
        if (webhooksData.success) {
          setWebhooks(webhooksData.webhooks);
          
        
          const newStatusTimers = {};
          webhooksData.webhooks.forEach(webhook => {
            const taskLink = webhook.TaskLink || webhook.taskLink;
            const taskStatus = webhook.TaskStatus || webhook.taskStatus;
            const receivedAt = webhook.receivedAt;
            
            if (taskLink && receivedAt && (taskStatus === 'В роботі' || taskStatus === 'В работе' || 
                taskStatus === 'В черзі' || taskStatus === 'В очереди')) {
              newStatusTimers[taskLink] = calculateTimeInStatus(receivedAt);
            }
          });
          setStatusTimers(newStatusTimers);
        } else {
          setError('Невірний формат даних від сервера');
        }

        if (archiveData.success) {
          setArchivedTasks(archiveData.archivedTasks || []);
        }
        
      } catch (error) {
        console.error('Помилка завантаження даних:', error);
        setError(`Помилка завантаження даних: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
    const interval = setInterval(fetchData, 1000);
    return () => clearInterval(interval);
  }, [userId]);


  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTimers = {};
      webhooks.forEach(webhook => {
        const taskLink = webhook.TaskLink || webhook.taskLink;
        const taskStatus = webhook.TaskStatus || webhook.taskStatus;
        const receivedAt = webhook.receivedAt;
        
        if (taskLink && receivedAt && (taskStatus === 'В роботі' || taskStatus === 'В работе' || 
            taskStatus === 'В черзі' || taskStatus === 'В очереди')) {
          updatedTimers[taskLink] = calculateTimeInStatus(receivedAt);
        }
      });
      setStatusTimers(updatedTimers);
    }, 1000);
    
    return () => clearInterval(interval);
  }, [webhooks]);


  const groupedByTask = webhooks.reduce((acc, webhook) => {
    const taskLink = webhook.TaskLink || webhook.taskLink || 'unknown';
    
  
    const archivedLinks = getArchivedTaskLinks();
    if (archivedLinks.includes(taskLink)) {
      return acc;
    }
    
    if (!acc[taskLink]) {
      acc[taskLink] = [];
    }
    acc[taskLink].push(webhook);
    return acc;
  }, {});


  const latestWebhooks = Object.entries(groupedByTask).map(([taskLink, taskWebhooks]) => {
    taskWebhooks.sort((a, b) => new Date(b.receivedAt) - new Date(a.receivedAt));
    return taskWebhooks[0];
  });


const generalPoolTasks = latestWebhooks.filter(task => {
   
    const taskStatus = String(task.TaskStatus || task.taskStatus || '');
    const taskPersonalPoint = String(task.TaskPersonalPoint || task.taskPersonalPoint || '');
    const taskName = String(task.TaskName || task.taskName || '');
    const implementerTask = String(task.implementer_task || task.ImplementerTask || '');
    const taskLink = String(task.TaskLink || task.taskLink || '');
    
  
    const archivedLinks = getArchivedTaskLinks();
    const isArchived = archivedLinks.includes(taskLink);
    
    const isNotPersonal = taskPersonalPoint === 'Ні' || taskPersonalPoint === 'Нет' || taskPersonalPoint === 'No';
    const isGeneralPoolStatus = taskStatus === 'Черговому' || taskStatus === 'Дежурному';
    const isNotImplementerTask = implementerTask !== 'Yes' && implementerTask !== 'Так';
    

    const excludedNames = ['Заявка №', 'Oбед ', 'Обід ', 'Обед ', 'Чергування / Дежурство -- Менторство', 'Чергування '];
    

    const shouldExclude = excludedNames.some(name => {
      const nameTrimmed = name.trim().toLowerCase();
      const taskNameLower = taskName.toLowerCase();
      
     
      const regex = new RegExp(`(^|\\s)${nameTrimmed}(\\s|$)`, 'i');
      return regex.test(taskName);
    });
    

    
    return isGeneralPoolStatus && isNotPersonal && isNotImplementerTask && !shouldExclude && !isArchived;
  });

 
const personalPoolTasks = latestWebhooks.filter(task => {
    const taskPersonalPoint = task.TaskPersonalPoint || task.taskPersonalPoint;
    const taskStatus = task.TaskStatus || task.taskStatus;
    const hide = task.hide || 'no';
    const taskName = String(task.TaskName || task.taskName || '').toLowerCase();
    const taskLink = String(task.TaskLink || task.taskLink || '');
    

    
 
    if (hide === 'yes' || hide === 'Yes') {
        console.log('Задача прихована:', taskName);
        return false;
    }
    
    
    const isPersonal = taskPersonalPoint === 'Так' || taskPersonalPoint === 'Да' || taskPersonalPoint === 'Yes';
    const isNotCompleted = taskStatus !== 'Скасоване' && taskStatus !== 'Отмененная'  && taskStatus !== 'Canceled' && 
                          taskStatus !== 'Виконане' && taskStatus !== 'Выполненная' && taskStatus !== 'Ready for review'&& 
                          taskStatus !== 'Завершене' && taskStatus !== 'Завершенная' && taskStatus !== 'Ready for review'&& 
                            taskStatus !== 'На доробці' && taskStatus !== 'На доработке' && taskStatus !== 'For improvement'&& 
                          taskStatus !== 'Deleted' && taskStatus !== 'Deleted';
    
 
    const isNotBallNotWithUs = taskStatus !== "В черзі (м'яч не у нас)" && 
                              taskStatus !== "В очереди (мяч не у нас)";
    
  
    const archivedLinks = getArchivedTaskLinks();
    const isArchived = archivedLinks.includes(taskLink);
    

    const excludedNames = ['заявка №', 'oбед ', 'обід ', 'обед ', 'чергування / дежурство -- менторство', 'чергування '];
    
    
    const shouldExclude = excludedNames.some(name => {
    
        const startsWithExcluded = taskName.startsWith(name.trim());
   
        const containsExcluded = new RegExp(`(^|\\s)${name.trim()}(\\s|$)`, 'i').test(taskName);
        
        if (startsWithExcluded || containsExcluded) {
    
            return true;
        }
        return false;
    });
    
    const result = isPersonal && isNotCompleted && isNotBallNotWithUs && !isArchived && !shouldExclude;
    
    if (result && taskName.includes('заявка')) {
     
    }
    
    return result;
});


  const getSortedPersonalPoolTasks = () => {
    const sortedTasks = [...personalPoolTasks];
    
    sortedTasks.sort((a, b) => {
      const statusA = a.TaskStatus || a.taskStatus || '';
      const statusB = b.TaskStatus || b.taskStatus || '';
      
      const priorityMap = {
        'В роботі': 1,
        'В работе': 1,
        'В черзі': 2,
        'В очереди': 2,
        'Відкладене': 3,
        'Отложенная': 3
      };
      
      const priorityA = priorityMap[statusA] || 4;
      const priorityB = priorityMap[statusB] || 4;
      
      return priorityA - priorityB;
    });
    
    return sortedTasks;
  };

  const TaskCard = ({ task, isGeneral }) => {
    const isBlocker = task.isBlocker === 'Термінове' || task.IsBlocker === 'Термінове' || 
                      task.isBlocker === 'Срочная' || task.IsBlocker === 'Срочная';
    const taskLink = task.TaskLink || task.taskLink;
    const taskName = task.TaskName || task.taskName || 'Без назви';
    const startdate = task.startdate;
    const taskStatus = task.TaskStatus || task.taskStatus;
    const taskTimer = task.TaskTimer || task.taskTimer;
    const receivedAt = task.receivedAt;
    
    let endTime, timeLeft, generalPoolTime, timeInStatus;
    let cardVariant = 'default';
    

    if (!isGeneral && (taskStatus === 'В роботі' || taskStatus === 'В работе' || 
        taskStatus === 'В черзі' || taskStatus === 'В очереди')) {
      timeInStatus = statusTimers[taskLink] || calculateTimeInStatus(receivedAt);
    }
    
    if (isGeneral) {
      if (startdate) {
        const startDateTime = new Date(startdate.replace(', ', 'T'));
        endTime = new Date(startDateTime.getTime() + 10 * 60 * 1000);
        timeLeft = calculateTimeLeft(endTime, startdate.replace(', ', 'T'));
        
        generalPoolTime = calculateGeneralPoolTime(startdate);
      }
    } else {
      if (taskStatus === 'Відкладене' || taskStatus === 'Отложенная') {
        cardVariant = 'postponed';
      } else if (taskStatus === 'В черзі' || taskStatus === 'В очереди') {
        cardVariant = 'queued';
        if (taskTimer) {
          endTime = calculateEndTime(receivedAt, taskTimer);
          timeLeft = endTime ? calculateTimeLeft(endTime, receivedAt) : null;
        }
      } else if (taskStatus === 'В роботі' || taskStatus === 'В работе') {
        cardVariant = 'in-progress';
      } else {
        if (taskTimer) {
          endTime = calculateEndTime(receivedAt, taskTimer);
          timeLeft = endTime ? calculateTimeLeft(endTime, receivedAt) : null;
        }
      }
    }
    
    const isReversed = reversedTimers[taskLink];
    const isExpired = timeLeft?.expired;
    
    const showGeneralTimer = isGeneral && timeLeft && !isExpired;
    const showGeneralPoolTimer = isGeneral && generalPoolTime;
    
    const showPersonalTimer = !isGeneral && cardVariant === 'queued' && timeLeft && !isExpired;
    const showExpiredTime = !isGeneral && cardVariant === 'queued' && isExpired && timeLeft?.endTime;
    
 
    const showStatusTimer = timeInStatus && !isGeneral && 
                           (cardVariant === 'in-progress' || 
                            cardVariant === 'queued');

    return (
      <div className={`task-card ${isBlocker ? 'blocker' : ''} ${isGeneral ? 'general' : 'personal'} ${cardVariant} ${isExpired ? 'expired' : ''}`}>
        {}
        {showGeneralTimer && (
          <div className="task-progress" style={{
            width: timeLeft ? `${timeLeft.percentage}%` : '0%',
            left: '0',
            right: 'auto'
          }}></div>
        )}
        
        {}
        {showGeneralPoolTimer && (
          <div className="task-progress general-pool-time" style={{
            width: '100%',
            left: '0',
            right: 'auto',
            backgroundColor: '#ff6b6b' 
          }}></div>
        )}
        
        {}
        {showPersonalTimer && (
          <div className="task-progress" style={{
            width: timeLeft ? `${isReversed ? 100 - timeLeft.percentage : timeLeft.percentage}%` : '0%',
            left: isReversed ? '0' : 'auto',
            right: isReversed ? 'auto' : '0'
          }}></div>
        )}
        
        <div className="task-content">
          {}
          {!isGeneral && cardVariant === 'queued' && timeLeft && !isExpired && (
            <button 
              className="reverse-timer-btn"
              onClick={() => toggleTimerDirection(taskLink)}
              aria-label="Змінити напрямок таймера"
            >
              ↻
            </button>
          )}
          
          {}
          {showGeneralTimer && (
            <div className="task-timer">{timeLeft.text}</div>
          )}
          
          {}
          {showGeneralPoolTimer && (
            <div className="task-timer general-pool-timer">{generalPoolTime.text}</div>
          )}
          
          {}
          {showPersonalTimer && (
            <div className="task-timer">{timeLeft.text}</div>
          )}
          
          {}
          {showStatusTimer && (
            <div className="task-timer status-timer">{timeInStatus.text}</div>
          )}
          
          {}
          {showExpiredTime && (
            <div className="task-expired-time expired-timer">{formatEndTime(timeLeft.endTime)}</div>
          )}
          
          {}
          {isGeneral && startdate && (
            <div className="task-startdate">{formatStartDate(startdate)}</div>
          )}
          
          <div className="task-info">
            <div className="task-name">{taskName}</div>
          </div>
          
          <div className="task-actions">
            <a 
              href={taskLink} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="task-link-btn"
            >
              →
            </a>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return <div className="tasks-page"><div className="loading">Завантаження...</div></div>;
  }

  if (error) {
    return <div className="tasks-page"><div className="error">{error}</div></div>;
  }

  const sortedPersonalPoolTasks = getSortedPersonalPoolTasks();

  return (
    <div className={`tasks-page ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`}>
      <div className="pool-section pip-target-element">
        <div className="pool-header">
          <div className="pool-header-left">
            <div className="pool-title-m">
              Загальний пул
              <span className="task-count-m">({generalPoolTasks.length})</span>
            </div>
          </div>
          <button 
            className="collapse-btn"
            onClick={() => setIsGeneralPoolCollapsed(!isGeneralPoolCollapsed)}
            aria-label={isGeneralPoolCollapsed ? "Розгорнути" : "Згорнути"}
          >
            {isGeneralPoolCollapsed ? '▼' : '▲'}
          </button>
        </div>
        
        {!isGeneralPoolCollapsed && (
          <div className="tasks-list">
            {generalPoolTasks.length === 0 ? (
              <div className="no-tasks">Немає завдань у загальному пулі</div>
            ) : (
              generalPoolTasks.map(task => (
                <TaskCard key={task.TaskLink || task.taskLink} task={task} isGeneral={true} />
              ))
            )}
          </div>
        )}
      </div>

      <div className="pool-section pip-target-element">
        <div className="pool-header">
          <div className="pool-header-left">
            <div className="pool-title-m">
              Особистий пул
              <span className="task-count-m">({sortedPersonalPoolTasks.length})</span>
            </div>
          </div>
          <button 
            className="collapse-btn"
            onClick={() => setIsPersonalPoolCollapsed(!isPersonalPoolCollapsed)}
            aria-label={isPersonalPoolCollapsed ? "Розгорнути" : "Згорнути"}
          >
            {isPersonalPoolCollapsed ? '▼' : '▲'}
          </button>
        </div>
        
        {!isPersonalPoolCollapsed && (
          <div className="tasks-list">
            {sortedPersonalPoolTasks.length === 0 ? (
              <div className="no-tasks">Немає завдань в особистому пулі</div>
            ) : (
              sortedPersonalPoolTasks.map(task => (
                <TaskCard key={task.TaskLink || task.taskLink} task={task} isGeneral={false} />
              ))
            )}
          </div>
        )}
      </div>

      <button className="pip-toggle-btn" onClick={handlePipToggle}>
        📌 PiP Mode
      </button>
    </div>
  );
}

export default TasksPage;

// import React, { useState, useEffect, useRef, useCallback, memo } from 'react';
// import "./TasksPage.css";
// import { useAuth } from '../auth/Auth';

// // Мапа імен користувачів
// const userNamesMap = {
//   '261': 'Пастушенко Карина',
//   '262': "Левицький Мар'ян",
//   '263': 'Стецько Андрій',
//   '264': 'Сенишин Максим',
//   '265': 'Грет Орест',
//   '266': 'Козак Дмитро',
//   '267': 'Герій Олег',
//   '268': 'Островська Катерина',
//   '269': 'Павлюк Микола',
//   '270': 'Коневич Роман',
//   '271': 'Здеорук Вікторія',           // ID користувача
//   '272': 'Чічкін Ігор',
//   '273': 'Рихлінський Руслан',
//   '274': 'Віролюбова Анастасія',
//   '275': 'Николайчук Дарья',
//   '276': 'Єсипович Євген',
//   '277': 'Левицький Микита',
//   '278': 'Здеорук Олександра',
//   '279': 'Петрів Юрій',
//   '280': 'Петрів Степан',
//   '281': 'Рось Іван',
//   '282': 'Бишко Данило',
//   '283': 'Сальников Валентин',
//   '285': 'Ванденко Максим',
//   '286': 'Зеленіков Дмитро',
//   '287': 'Сачовська Діана',
//   '288': 'Дудар Максим',
//   '289': 'Мелих Владислав',
//   '1991279261': 'Здеорук Вікторія',
  
//   // Додайте ВІДПОВІДНІСТЬ між хешами та ID
//   '08a376410d57a49080f6437a6769e765': 'Пастушенко Карина',
//   '6186dc0de930c4489f1cb0263fee3cb9': "Левицький Мар'ян",
//   '96936d574385ce2328b697d75cc9ed25': 'Стецько Андрій',
//   '7ae8cd52c6b536e7948e163d7eb79be1': 'Сенишин Максим',
//   '1c6c7ce92c2e99adb56f8a8743ef2c42': 'Грет Орест',
//   '181919b1f3bb927d217d617c4938a885': 'Козак Дмитро',
//   'e33d394cde1c7788e4371a5df8c91e7f': 'Герій Олег',
//   '888c3b61bb6fc84e462cace3802f5a80': 'Островська Катерина',
//   '68cbc91a9357786b674d12f48dbeec5e': 'Павлюк Микола',
//   '32478442b5013f8cef0c0a8b07f72dce': 'Коневич Роман',
//   'ed863fbec1ec7d6360f62d54942f0655': 'Здеорук Вікторія',  // Це ВАШ хеш!
//   '8c0d7c9a8853178be96fa60ed8b0298b': 'Чічкін Ігор',
//   '7115979f5af389e660bf57e21e10e73a': 'Рихлінський Руслан',
//   '9e91681968c552d39c3943cd489de8dd': 'Віролюбова Анастасія',
//   '1e9b56558fc6ef081b646ebce9c6d2b7': 'Николайчук Дарья',
//   'e90cbdecf165c5b7501e6b52315e0481': 'Єсипович Євген',
//   'ecb7033508c49fefc6f146fed1cdbde6': 'Левицький Микита',
//   '70d9217877877f35c58a57729a36455e': 'Здеорук Олександра',
//   '6b00290e92ccab45f933e1118fbc36f8': 'Петрів Юрій',
//   '253db11e2987d6eebe524da08ca3c33a': 'Петрів Степан',
//   '19149f434b36af055a1a14ee7dea719d': 'Рось Іван',
//   '84053c23a95a2f20256e351a6464f38e': 'Бишко Данило',
//   '70bab5c0b422829d5f51dd0c1a6a925e': 'Сальников Валентин',
//   'ed2024a4e80d57e488ae8c16d6bc52eb': 'Зеленіков Дмитро',
//   '045205e9750e89e7aa8a88eea1e90ba1': 'Сачовська Діана',
//   '528295c587f8204164b129b01c68f1f9': 'Дудар Максим',
//   '4514b8da7b9d9ae0f612eb3a9316c2ee': 'Мелих Владислав',
//   '5a2471cc0559c9bed479ebeaa2810456': 'Ванденко Максим',
//   '43481fb68ba4c410a7413a331ae63e2d': 'Шершньов Микита',
//   'd9bc61c8d39e7373c61e61a04073b9a8': 'Гіщинський Любомир',
//   '4fee0b2cd341f9ca21a174006703164d': 'Лебідь Роман',
// };

// // Функція для отримання імені користувача
// const getUserName = (userId) => {
//   if (!userId) return 'Невідомий';
//   if (userNamesMap[userId]) return userNamesMap[userId];
//   if (userNamesMap[String(userId)]) return userNamesMap[String(userId)];
//   return userId;
// };

// // Оптимальний MentorConnectTimer без моргання
// const MentorConnectTimer = memo(({ answer }) => {
//   const [timeText, setTimeText] = useState(() => {
//     // Ініціалізація з правильним значенням
//     if (!answer) return '';
//     if (answer.answerType === 'later' && answer.minutes > 0) {
//       const answeredAt = new Date(answer.answeredAt);
//       const targetTime = new Date(answeredAt.getTime() + answer.minutes * 60000);
//       const now = new Date();
//       const remainingMs = targetTime - now;
      
//       if (remainingMs > 0) {
//         const remainingMinutes = Math.floor(remainingMs / 60000);
//         const remainingSeconds = Math.floor((remainingMs % 60000) / 1000);
//         return `${remainingMinutes}:${remainingSeconds.toString().padStart(2, '0')}`;
//       } else {
//         const overdueMs = -remainingMs;
//         const overdueMinutes = Math.floor(overdueMs / 60000);
//         const overdueSeconds = Math.floor((overdueMs % 60000) / 1000);
//         return `+${overdueMinutes}:${overdueSeconds.toString().padStart(2, '0')}`;
//       }
//     }
//     return answer.answerType === 'now' ? 'Зараз' : '';
//   });
  
//   const [isOverdue, setIsOverdue] = useState(() => {
//     if (!answer) return false;
//     if (answer.answerType === 'later' && answer.minutes > 0) {
//       const answeredAt = new Date(answer.answeredAt);
//       const targetTime = new Date(answeredAt.getTime() + answer.minutes * 60000);
//       return new Date() > targetTime;
//     }
//     return false;
//   });
  
//   const timerRef = useRef(null);
//   const lastValueRef = useRef(timeText);
  
//   useEffect(() => {
//     if (!answer) return;
    
//     const updateTimer = () => {
//       if (answer.answerType === 'later' && answer.minutes > 0) {
//         const answeredAt = new Date(answer.answeredAt);
//         const targetTime = new Date(answeredAt.getTime() + answer.minutes * 60000);
//         const now = new Date();
//         const remainingMs = targetTime - now;
        
//         let newText;
//         let newIsOverdue;
        
//         if (remainingMs > 0) {
//           const remainingMinutes = Math.floor(remainingMs / 60000);
//           const remainingSeconds = Math.floor((remainingMs % 60000) / 1000);
//           newText = `${remainingMinutes}:${remainingSeconds.toString().padStart(2, '0')}`;
//           newIsOverdue = false;
//         } else {
//           const overdueMs = -remainingMs;
//           const overdueMinutes = Math.floor(overdueMs / 60000);
//           const overdueSeconds = Math.floor((overdueMs % 60000) / 1000);
//           newText = `+${overdueMinutes}:${overdueSeconds.toString().padStart(2, '0')}`;
//           newIsOverdue = true;
//         }
        
//         // Зберігаємо нове значення перед оновленням
//         lastValueRef.current = newText;
//         setTimeText(newText);
//         setIsOverdue(newIsOverdue);
//       } else if (answer.answerType === 'now') {
//         if (timeText !== 'Зараз') {
//           lastValueRef.current = 'Зараз';
//           setTimeText('Зараз');
//           setIsOverdue(false);
//         }
//       }
//     };
    
//     // Оновлюємо відразу
//     updateTimer();
    
//     // Запускаємо інтервал
//     timerRef.current = setInterval(updateTimer, 1000);
    
//     return () => {
//       if (timerRef.current) {
//         clearInterval(timerRef.current);
//       }
//     };
//   }, [answer]);
  
//   if (!answer) return null;
  
//   // Запобігаємо показу пустого значення
//   const displayText = timeText || lastValueRef.current || '0:00';
  
//   return (
//     <div className="mentor-timer" style={{ 
//       display: 'inline-flex', 
//       alignItems: 'center', 
//       gap: '8px',
//       minWidth: '120px'
//     }}>
//       <span className="mentor-name" style={{ fontSize: '12px', fontWeight: '500' }}>
//         {getUserName(answer.mentorId)}
//       </span>
//       <span 
//         className={`timer-value ${isOverdue ? 'overdue' : ''}`}
//         style={{ 
//           fontSize: '14px', 
//           fontWeight: 'bold',
//           fontFamily: 'monospace',
//           minWidth: '70px',
//           display: 'inline-block',
//           textAlign: 'center',
//           fontVariantNumeric: 'tabular-nums'
//         }}
//       >
//         {displayText}
//       </span>
//     </div>
//   );
// });
// function TasksPage() {
//   const { user } = useAuth();
//   const [webhooks, setWebhooks] = useState([]);
//   const [archivedTasks, setArchivedTasks] = useState([]);
//   const [noHelpTasks, setNoHelpTasks] = useState([]);
//   const [askHelpTasksWithFullData, setAskHelpTasksWithFullData] = useState([]);
//   const [kpiTasks, setKpiTasks] = useState([]);
//   const [mentorTasks, setMentorTasks] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [reversedTimers, setReversedTimers] = useState({});
//   const [isGeneralPoolCollapsed, setIsGeneralPoolCollapsed] = useState(false);
//   const [isPersonalPoolCollapsed, setIsPersonalPoolCollapsed] = useState(false);
//   const [isAskHelpPoolCollapsed, setIsAskHelpPoolCollapsed] = useState(false);
//   const [statusTimers, setStatusTimers] = useState({});
//   const [theme, setTheme] = useState('white');
//   const [showNotification, setShowNotification] = useState(false);
//   const [notificationTask, setNotificationTask] = useState(null);
//   const [notificationTimer, setNotificationTimer] = useState(null);
//   const [notifiedSessions, setNotifiedSessions] = useState(new Set());
//   const [showInfoNotification, setShowInfoNotification] = useState(false);
//   const [infoNotificationTask, setInfoNotificationTask] = useState(null);
//   const [infoNotificationTimer, setInfoNotificationTimer] = useState(null);
//   const [infoNotifiedSessions, setInfoNotifiedSessions] = useState(new Set());
//   const [initialLoadComplete, setInitialLoadComplete] = useState(false);
//   const audioRef = useRef(null);
//   const [audioLoaded, setAudioLoaded] = useState(false);
  
//   const userId = user?.user_id || localStorage.getItem('userId') || '271';

//   // Функція для перевірки, чи потрібно виключити задачу (обід)
//   const shouldExcludeTask = (taskName) => {
//     if (!taskName) return false;
    
//     const lowerCaseName = taskName.toLowerCase();
    
//     const obidVariants = [
//       'обід', 'обед', 'обiд', 'обїд', 'oбід', 'oбед', 'oбiд', 'oбїд',
//       'обеда', 'обіда', 'ланч', 'ланча', 'lunch'
//     ];
    
//     for (const variant of obidVariants) {
//       if (lowerCaseName.includes(variant)) {
//         return true;
//       }
//     }
    
//     if (taskName.includes('Oбед') || taskName.includes('Oбід')) {
//       return true;
//     }
    
//     return false;
//   };

//   // Функція для отримання останнього статусу з KPI
//   const getLatestKpiStatus = (taskLink) => {
//     const taskKpiEntries = kpiTasks.filter(task => {
//       const taskLinkMatch = (task.TaskLink || task.taskLink) === taskLink;
//       return taskLinkMatch;
//     });
    
//     if (taskKpiEntries.length === 0) return null;
    
//     const sortedEntries = taskKpiEntries.sort((a, b) => 
//       new Date(b.receivedAt) - new Date(a.receivedAt)
//     );
    
//     const latestEntry = sortedEntries[0];
    
//     if (latestEntry.hide === 'Yes') {
//       return 'hidden';
//     } else {
//       return 'visible';
//     }
//   };

//   // Функція для отримання останнього ментора по задачі
//   const getLatestMentor = (taskLink) => {
//     const taskMentorEntries = mentorTasks.filter(task => {
//       const taskLinkMatch = (task.TaskLink || task.taskLink) === taskLink;
//       return taskLinkMatch;
//     });
    
//     if (taskMentorEntries.length === 0) return null;
    
//     const sortedEntries = taskMentorEntries.sort((a, b) => 
//       new Date(b.receivedAt) - new Date(a.receivedAt)
//     );
    
//     const latestEntry = sortedEntries[0];
//     return latestEntry.Mentor || latestEntry.mentor || '';
//   };

//   // Функція для завантаження конфігурації теми
//   const fetchThemeConfig = async () => {
//     try {
//       const response = await fetch(`https://hub2.daolog.net/user-theme-config/${userId}`);
//       if (response.ok) {
//         const config = await response.json();
//         setTheme(config.theme || 'white');
//       } else {
//         setTheme('white');
//       }
//     } catch (error) {
//       console.error('Error fetching theme config:', error);
//       setTheme('white');
//     }
//   };

//   // Функція для створення/оновлення теми
//   const updateThemeConfig = async (newTheme) => {
//     try {
//       const response = await fetch(`https://hub2.daolog.net/update-user-theme-config/${userId}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ theme: newTheme })
//       });
      
//       if (response.ok) {
//         const data = await response.json();
//         setTheme(data.theme);
//       }
//     } catch (error) {
//       console.error('Error updating theme config:', error);
//     }
//   };

//   // Функція для завантаження задач "Допомога не потрібна"
//   const fetchNoHelpTasks = async () => {
//     try {
//       const response = await fetch(`https://hub2.daolog.net/api/no-help-tasks`);
//       if (response.ok) {
//         const data = await response.json();
//         if (data.success) {
//           setNoHelpTasks(data.noHelpTasks || []);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching no help tasks:', error);
//     }
//   };

//   const fetchAskHelpTasksWithFullData = async () => {
//     try {
//       console.log('🔄 Оновлення даних з ask-help.json...');
//       const response = await fetch(`https://hub2.daolog.net/api/ask-help-tasks-with-full-data`);
//       if (response.ok) {
//         const data = await response.json();
//         if (data.success) {
//           console.log(`✅ Отримано ${data.askHelpTasksWithFullData.length} задач з ask-help.json`);
//           setAskHelpTasksWithFullData(data.askHelpTasksWithFullData || []);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching ask help tasks with full data:', error);
//     }
//   };

//   // Функція для завантаження KPI задач
//   const fetchKpiTasks = async () => {
//     try {
//       const response = await fetch(`https://hub2.daolog.net/api/kpi-tasks`);
//       if (response.ok) {
//         const data = await response.json();
//         if (data.success) {
//           setKpiTasks(data.kpiTasks || []);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching KPI tasks:', error);
//     }
//   };

//   // Функція для завантаження менторських задач
//   const fetchMentorTasks = async () => {
//     try {
//       const response = await fetch(`https://hub2.daolog.net/api/mentor-tasks`);
//       if (response.ok) {
//         const data = await response.json();
//         if (data.success) {
//           setMentorTasks(data.mentorTasks || []);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching mentor tasks:', error);
//     }
//   };

//   // Функція для додавання задачі в "Допомога не потрібна"
//   const addNoHelpTask = async (taskData) => {
//     try {
//       const response = await fetch(`https://hub2.daolog.net/api/no-help-task`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           taskData: {
//             ...taskData,
//             sessionId: `${taskData.TaskLink || taskData.taskLink}_${new Date(taskData.receivedAt).getTime()}`,
//             receivedAt: taskData.receivedAt
//           },
//           markedBy: userId,
//           markedAt: new Date().toISOString()
//         })
//       });
      
//       if (response.ok) {
//         const data = await response.json();
//         if (data.success) {
//           await fetchNoHelpTasks();
          
//           const taskSessionId = `${taskData.TaskLink || taskData.taskLink}_${new Date(taskData.receivedAt).getTime()}`;
//           setNotifiedSessions(prev => {
//             const newSet = new Set(prev);
//             newSet.add(taskSessionId);
//             return newSet;
//           });
//         }
//       }
//     } catch (error) {
//       console.error('Error adding no help task:', error);
//     }
//   };

//   const addAskHelpTask = async (taskData) => {
//     try {
//       console.log('Відправка запиту на допомогу...');
      
//       const sessionId = `${taskData.TaskLink || taskData.taskLink}_${new Date(taskData.receivedAt).getTime()}`;
      
//       const response = await fetch(`https://hub2.daolog.net/api/ask-help-task`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           taskData: {
//             ...taskData,
//             sessionId: sessionId,
//             receivedAt: taskData.receivedAt
//           },
//           markedBy: userId,
//           markedAt: new Date().toISOString()
//         })
//       });
      
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
      
//       const data = await response.json();
      
//       if (data.success) {
//         console.log('Запит на допомогу успішно додано');
        
//         // ПРИМУСОВО ОНОВЛЮЄМО ДАНІ КІЛЬКА РАЗІВ
//         await fetchAskHelpTasksWithFullData();
//         await new Promise(resolve => setTimeout(resolve, 500));
//         await fetchAskHelpTasksWithFullData();
//         await new Promise(resolve => setTimeout(resolve, 500));
//         await fetchAskHelpTasksWithFullData();
        
//         alert('Запит на допомогу надіслано!');
//       } else {
//         console.error('Помилка:', data.message);
//         alert(`Помилка: ${data.message}`);
//       }
//     } catch (error) {
//       console.error('Помилка додавання запиту:', error);
//       alert(`Не вдалося надіслати запит: ${error.message}`);
//     }
//   };
//   const cancelAskHelpTask = async (sessionId) => {
//     try {
//       console.log('Скасування запиту на допомогу...');
      
//       const response = await fetch(`https://hub2.daolog.net/api/ask-help-task-by-session/${encodeURIComponent(sessionId)}`, {
//         method: 'DELETE'
//       });
      
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
      
//       const data = await response.json();
      
//       if (data.success) {
//         console.log('Запит на допомогу успішно скасовано');
        
//         // ПРИМУСОВО ОНОВЛЮЄМО ДАНІ
//         await fetchAskHelpTasksWithFullData();
        
//         // Додаткове оновлення через 1 секунду
//         setTimeout(async () => {
//           await fetchAskHelpTasksWithFullData();
//         }, 1000);
//       } else {
//         console.error('❌ Помилка:', data.message);
//       }
//     } catch (error) {
//       console.error('❌ Помилка скасування запиту:', error);
//     }
//   };
//   // Функція для перевірки, чи задача в списку "Допомога не потрібна"
//   const isNoHelpTask = (taskLink, receivedAt) => {
//     const sessionId = `${taskLink}_${new Date(receivedAt).getTime()}`;
//     return noHelpTasks.some(task => {
//       if (task.sessionId === sessionId) return true;
      
//       const taskReceivedAt = new Date(task.receivedAt || task.originalReceivedAt).getTime();
//       const currentReceivedAt = new Date(receivedAt).getTime();
      
//       return (task.TaskLink || task.taskLink) === taskLink && 
//              Math.abs(taskReceivedAt - currentReceivedAt) < 60000;
//     });
//   };

// // Функція для перевірки, чи задача в списку "Запитати допомогу" - з логуванням
// const isAskHelpTask = (taskLink, receivedAt) => {
//   const sessionId = `${taskLink}_${new Date(receivedAt).getTime()}`;
//   const result = askHelpTasksWithFullData.some(task => task.sessionId === sessionId);
//   console.log('isAskHelpTask:', { taskLink, sessionId, result, askHelpTasksCount: askHelpTasksWithFullData.length });
//   return result;
// };
// // Функція для перевірки, чи задача належить поточному користувачу (порівняння за ІМЕНЕМ)
// const isTaskBelongsToUser = (task) => {
//   const taskUser = task.User || task.user;
//   if (!taskUser) return false;
  
//   // Отримуємо ім'я поточного користувача
//   const currentUserName = getUserName(userId);
  
//   console.log('=== isTaskBelongsToUser ===');
//   console.log('Current user name:', currentUserName);
//   console.log('Task user(s):', taskUser);
  
//   if (Array.isArray(taskUser)) {
//     // Перевіряємо кожен елемент масиву - перетворюємо його в ім'я і порівнюємо
//     for (const user of taskUser) {
//       const userName = getUserName(user);
//       console.log(`  - Перевіряємо "${user}" -> ім'я: "${userName}"`);
//       if (userName === currentUserName) {
//         console.log('✅ ЗНАЙДЕНО СПІВПАДІННЯ!');
//         return true;
//       }
//     }
//     console.log('❌ Немає співпадінь');
//     return false;
//   }
  
//   // Для не-масиву
//   const taskUserName = getUserName(taskUser);
//   console.log(`  - taskUserName: "${taskUserName}"`);
//   console.log(`  - currentUserName: "${currentUserName}"`);
//   const result = taskUserName === currentUserName;
//   console.log(result ? '✅ СПІВПАДІННЯ!' : '❌ Немає співпадіння');
//   return result;
// };

//   // Функція для завантаження та відтворення звуку
//   const playNotificationSound = async () => {
//     try {
//       if (!audioLoaded) {
//         const response = await fetch('https://hub2.daolog.net/api/notification-sound');
        
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
        
//         const audioBlob = await response.blob();
//         const audioUrl = URL.createObjectURL(audioBlob);
        
//         if (audioRef.current) {
//           audioRef.current.pause();
//           audioRef.current.src = audioUrl;
//           audioRef.current.load();
//           setAudioLoaded(true);
          
//           setTimeout(() => {
//             audioRef.current.play().catch(error => {
//               console.error('Помилка відтворення звуку:', error);
//             });
//           }, 100);
//         }
//       } else {
//         if (audioRef.current) {
//           audioRef.current.currentTime = 0;
//           audioRef.current.play().catch(error => {
//             console.error('Помилка відтворення звуку:', error);
//           });
//         }
//       }
//     } catch (error) {
//       console.error('Помилка завантаження звукового файлу:', error);
//     }
//   };

//   // ОСНОВНИЙ useEffect ДЛЯ ПОЧАТКОВОГО ЗАВАНТАЖЕННЯ
//   useEffect(() => {
//     const loadAllData = async () => {
//       setLoading(true);
//       try {
//         await Promise.all([
//           fetchThemeConfig(),
//           fetchNoHelpTasks(),
//           fetchAskHelpTasksWithFullData(),
//           fetchKpiTasks(),
//           fetchMentorTasks()
//         ]);
//       } catch (error) {
//         console.error('Помилка завантаження даних:', error);
//         setError('Помилка завантаження даних');
//       } finally {
//         setLoading(false);
//         setInitialLoadComplete(true);
//       }
//     };
    
//     loadAllData();
    
//     audioRef.current = new Audio();
//     audioRef.current.preload = 'auto';
    
//     const preloadSound = async () => {
//       try {
//         const response = await fetch('https://hub2.daolog.net/api/notification-sound');
//         if (response.ok) {
//           const audioBlob = await response.blob();
//           const audioUrl = URL.createObjectURL(audioBlob);
//           audioRef.current.src = audioUrl;
//           audioRef.current.load();
//           setAudioLoaded(true);
//         }
//       } catch (error) {
//         console.error('Помилка попереднього завантаження звуку:', error);
//       }
//     };
    
//     preloadSound();
    
//     return () => {
//       if (audioRef.current) {
//         audioRef.current.pause();
//         audioRef.current.src = '';
//         audioRef.current = null;
//       }
//     };
//   }, [userId]);

//   // Окремий useEffect для завантаження webhooks після того, як userId відомий
//   useEffect(() => {
//     if (!userId || !initialLoadComplete) return;
    
//     const fetchWebhooks = async () => {
//       try {
//         const tokenResponse = await fetch(`https://hub2.daolog.net/api/user-token/${userId}`);
//         if (!tokenResponse.ok) return;
        
//         const tokenData = await tokenResponse.json();
//         const userToken = tokenData.token;
//         if (!userToken) return;
        
//         const webhooksResponse = await fetch(`https://hub2.daolog.net/api/pf-webhooks-by-token/${userToken}`);
//         if (!webhooksResponse.ok) return;
        
//         const webhooksData = await webhooksResponse.json();
//         if (webhooksData.success) {
//           setWebhooks(webhooksData.webhooks);
          
//           const newStatusTimers = {};
//           webhooksData.webhooks.forEach(webhook => {
//             const taskLink = webhook.TaskLink || webhook.taskLink;
//             const taskStatus = webhook.TaskStatus || webhook.taskStatus;
//             const receivedAt = webhook.receivedAt;
            
//             if (taskLink && receivedAt && (taskStatus === 'В роботі' || taskStatus === 'В работе' || 
//                 taskStatus === 'В черзі' || taskStatus === 'В очереди')) {
//               newStatusTimers[taskLink] = calculateTimeInStatus(receivedAt);
//             }
//           });
//           setStatusTimers(newStatusTimers);
//         }
//       } catch (error) {
//         console.error('Помилка завантаження вебхуків:', error);
//       }
//     };
    
//     fetchWebhooks();
//     const webhookInterval = setInterval(fetchWebhooks, 5000);
    
//     return () => clearInterval(webhookInterval);
//   }, [userId, initialLoadComplete]);
// // Додайте цей useEffect для примусового оновлення кожні 2 секунди
// useEffect(() => {
//   const interval = setInterval(() => {
//     fetchAskHelpTasksWithFullData();
//   }, 2000);
  
//   return () => clearInterval(interval);
// }, []);
//   // Інтервал для оновлення таймерів
//   useEffect(() => {
//     const interval = setInterval(() => {
//       const updatedTimers = {};
//       webhooks.forEach(webhook => {
//         const taskLink = webhook.TaskLink || webhook.taskLink;
//         const taskStatus = webhook.TaskStatus || webhook.taskStatus;
//         const receivedAt = webhook.receivedAt;
        
//         if (taskLink && receivedAt && (taskStatus === 'В роботі' || taskStatus === 'В работе' || 
//             taskStatus === 'В черзі' || taskStatus === 'В очереди')) {
//           updatedTimers[taskLink] = calculateTimeInStatus(receivedAt);
//         }
//       });
//       setStatusTimers(updatedTimers);
//     }, 1000);
    
//     return () => clearInterval(interval);
//   }, [webhooks]);

//   // Інтервал для завантаження архівованих задач
//   useEffect(() => {
//     const fetchArchived = async () => {
//       try {
//         const response = await fetch(`https://hub2.daolog.net/api/archived-tasks`);
//         if (response.ok) {
//           const data = await response.json();
//           if (data.success) {
//             setArchivedTasks(data.archivedTasks || []);
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching archived tasks:', error);
//       }
//     };
    
//     fetchArchived();
//     const interval = setInterval(fetchArchived, 10000);
//     return () => clearInterval(interval);
//   }, []);

//   // Перевіряємо задачі для сповіщення (10 хвилин)
//   useEffect(() => {
//     const checkForNotifications = () => {
//       const personalTasks = personalPoolTasks.filter(task => {
//         const taskStatus = task.TaskStatus || task.taskStatus;
//         const receivedAt = task.receivedAt;
//         const taskLink = task.TaskLink || task.taskLink;
        
//         if (!receivedAt || taskStatus !== 'В роботі' && taskStatus !== 'В работе') return false;
        
//         const timeInProgress = calculateTimeInStatus(receivedAt);
//         if (!timeInProgress) return false;
        
//         const minutes = Math.floor(timeInProgress.totalTimeInMs / (1000 * 60));
        
//         const isNoHelp = isNoHelpTask(taskLink, receivedAt);
//         const taskSessionId = `${taskLink}_${new Date(receivedAt).getTime()}`;
//         const hasBeenNotified = notifiedSessions.has(taskSessionId);
        
//         const kpiStatus = getLatestKpiStatus(taskLink);
//         const isKpiHidden = kpiStatus === 'hidden';
        
//         const taskName = task.TaskName || task.taskName || '';
//         const isObed = shouldExcludeTask(taskName);
        
//         const mentor = getLatestMentor(taskLink);
//         const hasMentor = mentor && mentor.trim() !== '';
        
//         return minutes === 10 && !isNoHelp && !hasBeenNotified && !isKpiHidden && !isObed && !hasMentor;
//       });

//       if (personalTasks.length > 0 && !showNotification) {
//         const task = personalTasks[0];
//         const taskSessionId = `${task.TaskLink || task.taskLink}_${new Date(task.receivedAt).getTime()}`;
        
//         setNotifiedSessions(prev => {
//           const newSet = new Set(prev);
//           newSet.add(taskSessionId);
//           return newSet;
//         });
        
//         setNotificationTask(task);
//         setShowNotification(true);
        
//         playNotificationSound();
        
//         const timer = setTimeout(() => {
//           setShowNotification(false);
//           setNotificationTask(null);
//         }, 10000);
        
//         setNotificationTimer(timer);
//       }
//     };

//     const interval = setInterval(checkForNotifications, 1000);
//     return () => {
//       clearInterval(interval);
//       if (notificationTimer) {
//         clearTimeout(notificationTimer);
//       }
//     };
//   }, [webhooks, noHelpTasks, kpiTasks, mentorTasks, showNotification, notifiedSessions]);

//   // Перевіряємо задачі для інформаційного сповіщення (45 хвилин)
//   useEffect(() => {
//     const checkForInfoNotifications = () => {
//       const personalTasks = personalPoolTasks.filter(task => {
//         const taskStatus = task.TaskStatus || task.taskStatus;
//         const receivedAt = task.receivedAt;
//         const taskLink = task.TaskLink || task.taskLink;
        
//         if (!receivedAt || taskStatus !== 'В роботі' && taskStatus !== 'В работе') return false;
        
//         const timeInProgress = calculateTimeInStatus(receivedAt);
//         if (!timeInProgress) return false;
        
//         const minutes = Math.floor(timeInProgress.totalTimeInMs / (1000 * 60));
        
//         const taskSessionId = `${taskLink}_${new Date(receivedAt).getTime()}`;
//         const hasBeenNotified = infoNotifiedSessions.has(taskSessionId);
        
//         const kpiStatus = getLatestKpiStatus(taskLink);
//         const isKpiHidden = kpiStatus === 'hidden';
        
//         const taskName = task.TaskName || task.taskName || '';
//         const isObed = shouldExcludeTask(taskName);
        
//         const mentor = getLatestMentor(taskLink);
//         const hasMentor = mentor && mentor.trim() !== '';
        
//         return minutes === 45 && !hasBeenNotified && !isKpiHidden && !isObed && !hasMentor;
//       });

//       if (personalTasks.length > 0 && !showInfoNotification) {
//         const task = personalTasks[0];
//         const taskSessionId = `${task.TaskLink || task.taskLink}_${new Date(task.receivedAt).getTime()}`;
        
//         setInfoNotifiedSessions(prev => {
//           const newSet = new Set(prev);
//           newSet.add(taskSessionId);
//           return newSet;
//         });
        
//         setInfoNotificationTask(task);
//         setShowInfoNotification(true);
        
//         playNotificationSound();
        
//         const timer = setTimeout(() => {
//           setShowInfoNotification(false);
//           setInfoNotificationTask(null);
//         }, 15000);
        
//         setInfoNotificationTimer(timer);
//       }
//     };

//     const interval = setInterval(checkForInfoNotifications, 1000);
//     return () => {
//       clearInterval(interval);
//       if (infoNotificationTimer) {
//         clearTimeout(infoNotificationTimer);
//       }
//     };
//   }, [webhooks, kpiTasks, mentorTasks, showInfoNotification, infoNotifiedSessions]);

//   const handlePipToggle = () => {
//     if (window.__interactiveTabPiP && window.__interactiveTabPiP.toggle) {
//       window.__interactiveTabPiP.toggle({
//         mode: 'element-only',
//         targetSelector: '.pip-target-element' 
//       });
//     } else {
//       alert('Для використання цієї функції необхідно встановити розширення "Interactive Tab PiP".');
//     }
//   };

//   const toggleTimerDirection = (taskLink) => {
//     setReversedTimers(prev => ({
//       ...prev,
//       [taskLink]: !prev[taskLink]
//     }));
//   };

//   const handleNoHelpClick = (task) => {
//     addNoHelpTask(task);
//   };
//   // Функція для отримання відповіді ментора на запит допомоги
// // Функція для отримання відповіді ментора на запит допомоги
// const getAnswerForTask = (taskLink, receivedAt) => {
//   const sessionId = `${taskLink}_${new Date(receivedAt).getTime()}`;
//   const taskData = askHelpTasksWithFullData.find(task => task.sessionId === sessionId);
//   return taskData?.answer || null;
// };

// // Функція для перевірки, чи відмовився ментор
// const isMentorDeclined = (taskLink, receivedAt) => {
//   const answer = getAnswerForTask(taskLink, receivedAt);
//   return answer && answer.work === 'done';
// };


// // Функція для перевірки, чи ментор прийняв задачу
// const isMentorAccepted = (taskLink, receivedAt) => {
//   const answer = getAnswerForTask(taskLink, receivedAt);
//   return answer && answer.work === 'accepted';
// };


// // Функція для оновлення webhooks даних
// const fetchWebhooksData = async () => {
//   if (!userId) return;
  
//   try {
//     const tokenResponse = await fetch(`https://hub2.daolog.net/api/user-token/${userId}`);
//     if (!tokenResponse.ok) return;
    
//     const tokenData = await tokenResponse.json();
//     const userToken = tokenData.token;
//     if (!userToken) return;
    
//     const webhooksResponse = await fetch(`https://hub2.daolog.net/api/pf-webhooks-by-token/${userToken}`);
//     if (!webhooksResponse.ok) return;
    
//     const webhooksData = await webhooksResponse.json();
//     if (webhooksData.success) {
//       setWebhooks(webhooksData.webhooks);
      
//       const newStatusTimers = {};
//       webhooksData.webhooks.forEach(webhook => {
//         const taskLink = webhook.TaskLink || webhook.taskLink;
//         const taskStatus = webhook.TaskStatus || webhook.taskStatus;
//         const receivedAt = webhook.receivedAt;
        
//         if (taskLink && receivedAt && (taskStatus === 'В роботі' || taskStatus === 'В работе' || 
//             taskStatus === 'В черзі' || taskStatus === 'В очереди')) {
//           newStatusTimers[taskLink] = calculateTimeInStatus(receivedAt);
//         }
//       });
//       setStatusTimers(newStatusTimers);
//     }
//   } catch (error) {
//     console.error('Помилка оновлення вебхуків:', error);
//   }
// };
// // Функція для перевірки, чи є відповідь на запит
// const hasAnswerForTask = (taskLink, receivedAt) => {
//   return !!getAnswerForTask(taskLink, receivedAt);
// };

// const handleAskHelpClick = async (task) => {
//   const taskLink = task.TaskLink || task.taskLink;
//   const receivedAt = task.receivedAt;
//   const sessionId = `${taskLink}_${new Date(receivedAt).getTime()}`;
  
//   // Оновлюємо дані перед перевіркою
//   await fetchAskHelpTasksWithFullData();
  
//   const isAskHelp = isAskHelpTask(taskLink, receivedAt);
//   const taskData = askHelpTasksWithFullData.find(t => t.sessionId === sessionId);
//   const answer = taskData?.answer;
//   const isDeclined = answer?.work === 'done';
//   const isAccepted = answer?.work === 'accepted';
  
//   console.log('🔍 handleAskHelpClick стан:', {
//     taskName: task.TaskName,
//     isAskHelp,
//     isDeclined,
//     isAccepted,
//     hasAnswer: !!answer
//   });
  
//   // Якщо ментор прийняв - не дозволяємо
//   if (isAccepted) {
//     alert('Неможливо скасувати запит - ментор вже взяв задачу в роботу');
//     return;
//   }
  
//   // Якщо є відповідь (відмова або будь-яка інша) - видаляємо старий запит
//   if (answer) {
//     console.log('📤 Видаляємо старий запит (відповідь вже є)');
//     await cancelAskHelpTask(sessionId);
//     // Чекаємо видалення
//     await new Promise(resolve => setTimeout(resolve, 500));
//     await fetchAskHelpTasksWithFullData();
//   }
  
//   // Створюємо новий запит
//   console.log('📤 Створюємо новий запит');
//   await addAskHelpTask(task);
  
//   // Примусове оновлення після створення
//   setTimeout(async () => {
//     await fetchAskHelpTasksWithFullData();
//     console.log('🔄 Фінальне оновлення даних');
//   }, 1000);
// };
//   const handleCloseNotification = () => {
//     setShowNotification(false);
//     setNotificationTask(null);
//     if (notificationTimer) {
//       clearTimeout(notificationTimer);
//       setNotificationTimer(null);
//     }
//   };

//   const handleNotificationNoHelp = () => {
//     if (notificationTask) {
//       addNoHelpTask(notificationTask);
//     }
//     handleCloseNotification();
//   };

//   const handleCloseInfoNotification = () => {
//     setShowInfoNotification(false);
//     setInfoNotificationTask(null);
//     if (infoNotificationTimer) {
//       clearTimeout(infoNotificationTimer);
//       setInfoNotificationTimer(null);
//     }
//   };

//   const calculateTimeInStatus = (receivedAt) => {
//     if (!receivedAt) return null;
    
//     const statusTime = new Date(receivedAt);
//     const now = new Date();
//     const timeInStatus = now - statusTime;
    
//     const totalSeconds = Math.floor(timeInStatus / 1000);
//     const hours = Math.floor(totalSeconds / 3600);
//     const minutes = Math.floor((totalSeconds % 3600) / 60);
//     const seconds = totalSeconds % 60;
    
//     return {
//       hours: hours.toString().padStart(2, '0'),
//       minutes: minutes.toString().padStart(2, '0'),
//       seconds: seconds.toString().padStart(2, '0'),
//       text: `${hours > 0 ? `${hours}:` : ''}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
//       totalTimeInMs: timeInStatus
//     };
//   };

//   const calculateEndTime = (receivedAt, taskTimer) => {
//     if (!taskTimer) return null;
    
//     const startTime = new Date(receivedAt);
//     const timerMatch = taskTimer.match(/(\d+)\s*(хв|год)/);
    
//     if (!timerMatch) return null;
    
//     const value = parseInt(timerMatch[1]);
//     const unit = timerMatch[2];
    
//     if (unit === 'хв') {
//       startTime.setMinutes(startTime.getMinutes() + value);
//     } else if (unit === 'год') {
//       startTime.setHours(startTime.getHours() + value);
//     }
    
//     return startTime;
//   };

//   const calculateTimeLeft = (endTime, receivedAt) => {
//     const now = new Date();
//     const difference = endTime - now;
    
//     if (difference <= 0) {
//       return { 
//         expired: true, 
//         text: '', 
//         percentage: 100,
//         endTime: endTime
//       };
//     }
    
//     const hours = Math.floor(difference / (1000 * 60 * 60));
//     const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
//     const seconds = Math.floor((difference % (1000 * 60)) / 1000);
    
//     const totalTime = endTime - new Date(receivedAt);
//     const percentage = totalTime > 0 ? 100 - (difference / totalTime * 100) : 0;
    
//     return {
//       expired: false,
//       hours: hours.toString().padStart(2, '0'),
//       minutes: minutes.toString().padStart(2, '0'),
//       seconds: seconds.toString().padStart(2, '0'),
//       text: `${hours > 0 ? `${hours}:` : ''}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
//       percentage: Math.min(Math.max(percentage, 0), 100),
//       endTime: endTime
//     };
//   };

//   const calculateGeneralPoolTime = (startdate) => {
//     if (!startdate) return null;
    
//     const startTime = new Date(startdate.replace(', ', 'T'));
//     const now = new Date();
//     const timeInPool = now - startTime; 
    
//     const tenMinutesInMs = 10 * 60 * 1000;
//     if (timeInPool <= tenMinutesInMs) {
//       return null; 
//     }
    
//     const totalSeconds = Math.floor(timeInPool / 1000);
//     const hours = Math.floor(totalSeconds / 3600);
//     const minutes = Math.floor((totalSeconds % 3600) / 60);
//     const seconds = totalSeconds % 60;
    
//     return {
//       hours: hours.toString().padStart(2, '0'),
//       minutes: minutes.toString().padStart(2, '0'),
//       seconds: seconds.toString().padStart(2, '0'),
//       text: `${hours > 0 ? `${hours}:` : ''}${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`,
//       totalTimeInMs: timeInPool
//     };
//   };

//   const formatStartDate = (startdate) => {
//     if (!startdate) return '';
//     const date = new Date(startdate.replace(', ', 'T'));
//     const hours = date.getHours().toString().padStart(2, '0');
//     const minutes = date.getMinutes().toString().padStart(2, '0');
//     return `${hours}:${minutes}`;
//   };

//   const formatEndTime = (endTime) => {
//     if (!endTime) return '';
//     const hours = endTime.getHours().toString().padStart(2, '0');
//     const minutes = endTime.getMinutes().toString().padStart(2, '0');
//     return `${hours}:${minutes}`;
//   };

//   const getArchivedTaskLinks = () => {
//     return archivedTasks.map(task => task.TaskLink || task.taskLink);
//   };

//   const groupedByTask = webhooks.reduce((acc, webhook) => {
//     const taskLink = webhook.TaskLink || webhook.taskLink || 'unknown';
    
//     const archivedLinks = getArchivedTaskLinks();
//     if (archivedLinks.includes(taskLink)) {
//       return acc;
//     }
    
//     if (!acc[taskLink]) {
//       acc[taskLink] = [];
//     }
//     acc[taskLink].push(webhook);
//     return acc;
//   }, {});

//   const latestWebhooks = Object.entries(groupedByTask).map(([taskLink, taskWebhooks]) => {
//     taskWebhooks.sort((a, b) => new Date(b.receivedAt) - new Date(a.receivedAt));
//     return taskWebhooks[0];
//   });

//   const generalPoolTasks = latestWebhooks.filter(task => {
//     const taskStatus = String(task.TaskStatus || task.taskStatus || '');
//     const taskPersonalPoint = String(task.TaskPersonalPoint || task.taskPersonalPoint || '');
//     const taskName = String(task.TaskName || task.taskName || '');
//     const implementerTask = String(task.implementer_task || task.ImplementerTask || '');
//     const taskLink = String(task.TaskLink || task.taskLink || '');
    
//     const archivedLinks = getArchivedTaskLinks();
//     const isArchived = archivedLinks.includes(taskLink);
    
//     const isNotPersonal = taskPersonalPoint === 'Ні' || taskPersonalPoint === 'Нет' || taskPersonalPoint === 'No';
//     const isGeneralPoolStatus = taskStatus === 'Черговому' || taskStatus === 'Дежурному';
//     const isNotImplementerTask = implementerTask !== 'Yes' && implementerTask !== 'Так';
    
//     const excludedNames = ['Заявка №', 'Oбед ', 'Обід ', 'Обед ', 'Чергування / Дежурство -- Менторство', 'Чергування '];
    
//     const shouldExclude = excludedNames.some(name => {
//       const nameTrimmed = name.trim().toLowerCase();
//       const taskNameLower = taskName.toLowerCase();
//       const regex = new RegExp(`(^|\\s)${nameTrimmed}(\\s|$)`, 'i');
//       return regex.test(taskNameLower);
//     });
    
//     return isGeneralPoolStatus && isNotPersonal && isNotImplementerTask && !shouldExclude && !isArchived;
//   });

//   const personalPoolTasks = latestWebhooks.filter(task => {
//     const taskPersonalPoint = task.TaskPersonalPoint || task.taskPersonalPoint;
//     const taskStatus = task.TaskStatus || task.taskStatus;
//     const hide = task.hide || 'no';
//     const taskName = String(task.TaskName || task.taskName || '').toLowerCase();
//     const taskLink = String(task.TaskLink || task.taskLink || '');
    
//     const kpiStatus = getLatestKpiStatus(taskLink);
//     const isKpiHidden = kpiStatus === 'hidden';
    
//     if (hide === 'yes' || hide === 'Yes') {
//       return false;
//     }
    
//     const isObed = shouldExcludeTask(taskName);
    
//     const isPersonal = taskPersonalPoint === 'Так' || taskPersonalPoint === 'Да' || taskPersonalPoint === 'Yes';
//     const isNotCompleted = taskStatus !== 'Скасоване' && taskStatus !== 'Отмененная'  && taskStatus !== 'Canceled' && 
//                           taskStatus !== 'Виконане' && taskStatus !== 'Выполненная' && taskStatus !== 'Ready for review'&& 
//                           taskStatus !== 'Завершене' && taskStatus !== 'Завершенная' && taskStatus !== 'Ready for review'&& 
//                           taskStatus !== 'Deleted' && taskStatus !== 'Deleted';
    
//     const isNotBallNotWithUs = taskStatus !== "В черзі (м'яч не у нас)" && 
//                               taskStatus !== "В очереди (мяч не у нас)";
    
//     const archivedLinks = getArchivedTaskLinks();
//     const isArchived = archivedLinks.includes(taskLink);
    
//     const excludedNames = ['заявка №', 'oбед ', 'обід ', 'обед ', 'чергування / дежурство -- менторство', 'чергування '];
    
//     const shouldExclude = excludedNames.some(name => {
//       const startsWithExcluded = taskName.startsWith(name.trim());
//       const containsExcluded = new RegExp(`(^|\\s)${name.trim()}(\\s|$)`, 'i').test(taskName);
//       return startsWithExcluded || containsExcluded;
//     });
    
//     return isPersonal && isNotCompleted && isNotBallNotWithUs && !isArchived && !shouldExclude;
//   });

// // Фільтрація задач для третьої колонки
// const askHelpPoolTasks = askHelpTasksWithFullData.filter(task => {
//   // Перевірка користувача
//   const currentUserName = getUserName(userId);
//   const taskUser = task.User || task.user;
//   if (!taskUser) return false;
  
//   let belongsToUser = false;
//   if (Array.isArray(taskUser)) {
//     for (const user of taskUser) {
//       if (getUserName(user) === currentUserName) {
//         belongsToUser = true;
//         break;
//       }
//     }
//   } else {
//     if (getUserName(taskUser) === currentUserName) {
//       belongsToUser = true;
//     }
//   }
//   if (!belongsToUser) return false;
  
//   // Отримуємо відповідь ментора
//   const answer = task.answer;
  
//   // ❌ ЯКЩО МЕНТОР ВІДМОВИВСЯ (work === 'done') - НЕ ПОКАЗУЄМО В ТРЕТІЙ КОЛОНЦІ
//   if (answer?.work === 'done') {
//     console.log(`❌ Задача "${task.TaskName}" - ментор відмовився, не показуємо`);
//     return false;
//   }
  
//   // Перевірка на скасування (беремо статус з webhooks)
//   const taskLink = task.TaskLink || task.taskLink;
//   const webhookTask = latestWebhooks.find(wh => (wh.TaskLink || wh.taskLink) === taskLink);
//   const actualStatus = webhookTask?.TaskStatus || webhookTask?.taskStatus || '';
//   const isCancelled = actualStatus === 'Скасоване' || actualStatus === 'Отмененная' || actualStatus === 'Canceled';
  
//   if (isCancelled) return false;
  
//   return true;
// });

// console.log('=========================================');
// console.log('РЕЗУЛЬТАТ: активних задач:', askHelpPoolTasks.length);
// askHelpPoolTasks.forEach(task => {
//   console.log(`  - ${task.TaskName} (статус: ${task.TaskStatus || task.taskStatus})`);
// });
// console.log('=========================================');

//   const getSortedPersonalPoolTasks = () => {
//     const sortedTasks = [...personalPoolTasks];
    
//     sortedTasks.sort((a, b) => {
//       const statusA = a.TaskStatus || a.taskStatus || '';
//       const statusB = b.TaskStatus || b.taskStatus || '';
      
//       const priorityMap = {
//         'В роботі': 1,
//         'В работе': 1,
//         'В черзі': 2,
//         'В очереди': 2,
//         'Відкладене': 3,
//         'Отложенная': 3
//       };
      
//       const priorityA = priorityMap[statusA] || 4;
//       const priorityB = priorityMap[statusB] || 4;
      
//       return priorityA - priorityB;
//     });
    
//     return sortedTasks;
//   };

// // Спрощена версія - хрестик зникає при будь-якій відповіді ментора
// const AskHelpTaskCard = ({ taskData }) => {
//   const task = taskData;
//   const isBlocker = task.isBlocker === 'Термінове' || task.IsBlocker === 'Термінове' || 
//                     task.isBlocker === 'Срочная' || task.IsBlocker === 'Срочная';
//   const taskLink = task.TaskLink || task.taskLink;
//   const taskName = task.TaskName || task.taskName || 'Без назви';
//   const taskStatus = task.TaskStatus || task.taskStatus;
//   const receivedAt = task.receivedAt;
  
//   const answer = task.answer;
//   const isDeclined = task.isDeclined;
  
//   // Якщо є відповідь і це не відмова - значить ментор в роботі
//   const hasActiveMentor = answer && !isDeclined;
  
//   let timeInStatus = null;
//   if (taskStatus === 'В роботі' || taskStatus === 'В работе' || 
//       taskStatus === 'В черзі' || taskStatus === 'В очереди') {
//     timeInStatus = statusTimers[taskLink] || calculateTimeInStatus(receivedAt);
//   }

//   return (
//     <div className={`task-card ${isBlocker ? 'blocker' : ''} personal ask-help-pool ${answer ? 'has-answer' : ''}`}>
//       <div className="task-content">
//         {/* Хрестик показуємо ТІЛЬКИ якщо немає активного ментора */}
//         {!hasActiveMentor && (
//           <button 
//             className="ask-help-btn marked"
//             onClick={() => handleAskHelpClick(task)}
//             title="Скасувати запит на допомогу"
//           >
//             ✗
//           </button>
//         )}
        
//         {/* Якщо є активний ментор - показуємо індикатор */}
//         {hasActiveMentor && (
//           <div className="mentor-working-indicator" style={{
//             display: 'inline-flex',
//             alignItems: 'center',
//             gap: '4px',
//             padding: '2px 8px',
//             backgroundColor: '#4caf50',
//             color: 'white',
//             borderRadius: '12px',
//             fontSize: '11px',
//             marginRight: '8px'
//           }}>
//             {getUserName(answer.mentorId)} в роботі
//           </div>
//         )}
        
//         {answer && !isDeclined && (
//           <MentorConnectTimer answer={answer} />
//         )}
        
//         {timeInStatus && (
//           <div className="task-timer status-timer">{timeInStatus.text}</div>
//         )}
        
//         <div className="task-info">
//           <div className="task-name">{taskName}</div>
//         </div>
        
//         <div className="task-actions">
//           <a 
//             href={taskLink} 
//             target="_blank" 
//             rel="noopener noreferrer" 
//             className="task-link-btn"
//           >
//             →
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// };
// // Компонент TaskCard для перших двох колонок (Особистий пул) - БЕЗ ЗМІН ВІЗУАЛУ
// const TaskCard = ({ task, isGeneral }) => {
//   const isBlocker = task.isBlocker === 'Термінове' || task.IsBlocker === 'Термінове' || 
//                     task.isBlocker === 'Срочная' || task.IsBlocker === 'Срочная';
//   const taskLink = task.TaskLink || task.taskLink;
//   const taskName = task.TaskName || task.taskName || 'Без назви';
//   const startdate = task.startdate;
//   const taskStatus = task.TaskStatus || task.taskStatus;
//   const taskTimer = task.TaskTimer || task.taskTimer;
//   const receivedAt = task.receivedAt;
  
//   const isNoHelp = isNoHelpTask(taskLink, receivedAt);
//   const isAskHelp = isAskHelpTask(taskLink, receivedAt);
  
//   // Отримуємо інформацію про відповідь ментора (тільки для логіки, НЕ ДЛЯ ВІЗУАЛУ)
//   const answer = getAnswerForTask(taskLink, receivedAt);
//   const isDeclinedByMentor = answer && answer.work === 'done';
//   const isAcceptedByMentor = answer && answer.work === 'accepted';
  
//   const kpiStatus = getLatestKpiStatus(taskLink);
//   const isKpiHidden = kpiStatus === 'hidden';
//   const isObed = shouldExcludeTask(taskName);
//   const mentor = getLatestMentor(taskLink);
//   const hasMentor = mentor && mentor.trim() !== '';
  
//   let cardVariant = 'default';
  
//   if (!isGeneral) {
//     if (taskStatus === 'Відкладене' || taskStatus === 'Отложенная') {
//       cardVariant = 'postponed';
//     } else if (taskStatus === 'В черзі' || taskStatus === 'В очереди') {
//       cardVariant = 'queued';
//     } else if (taskStatus === 'В роботі' || taskStatus === 'В работе') {
//       cardVariant = 'in-progress';
//     }
//   }
  
//   let timeInProgress = null;
//   if (!isGeneral && (taskStatus === 'В роботі' || taskStatus === 'В работе')) {
//     timeInProgress = calculateTimeInStatus(receivedAt);
//   }
  
//   const isNoHelpButtonActive = timeInProgress && !isNoHelp && (() => {
//     const minutes = Math.floor(timeInProgress.totalTimeInMs / (1000 * 60));
//     return minutes >= 15 && minutes <= 25;
//   })();
  
//   const shouldShowNoHelpButton = !isGeneral && 
//                                  cardVariant === 'in-progress' && 
//                                  !isKpiHidden && 
//                                  !isObed && 
//                                  !hasMentor;
  
//   // Кнопка "?" показується:
//   // 1. Якщо немає активного запиту (isAskHelp = false)
//   // 2. АБО якщо ментор відмовився (тоді isAskHelp = false, бо задача вже видалена з ask-help.json)
//   // Візуально кнопка виглядає так само - знак питання
//   const shouldShowAskHelpButton = !isGeneral && !isAskHelp;
  
//   let endTime, timeLeft, generalPoolTime, timeInStatus;
  
//   if (!isGeneral) {
//     if (taskStatus === 'В роботі' || taskStatus === 'В работе' || 
//         taskStatus === 'В черзі' || taskStatus === 'В очереди') {
//       timeInStatus = statusTimers[taskLink] || calculateTimeInStatus(receivedAt);
//     }
//   }
  
//   if (isGeneral) {
//     if (startdate) {
//       const startDateTime = new Date(startdate.replace(', ', 'T'));
//       endTime = new Date(startDateTime.getTime() + 10 * 60 * 1000);
//       timeLeft = calculateTimeLeft(endTime, startdate.replace(', ', 'T'));
      
//       generalPoolTime = calculateGeneralPoolTime(startdate);
//     }
//   } else {
//     if (cardVariant === 'queued' && taskTimer) {
//       endTime = calculateEndTime(receivedAt, taskTimer);
//       timeLeft = endTime ? calculateTimeLeft(endTime, receivedAt) : null;
//     } else if (cardVariant !== 'postponed' && cardVariant !== 'in-progress' && taskTimer) {
//       endTime = calculateEndTime(receivedAt, taskTimer);
//       timeLeft = endTime ? calculateTimeLeft(endTime, receivedAt) : null;
//     }
//   }
  
//   const isReversed = reversedTimers[taskLink];
//   const isExpired = timeLeft?.expired;
  
//   const showGeneralTimer = isGeneral && timeLeft && !isExpired;
//   const showGeneralPoolTimer = isGeneral && generalPoolTime;
  
//   const showPersonalTimer = !isGeneral && cardVariant === 'queued' && timeLeft && !isExpired;
//   const showExpiredTime = !isGeneral && cardVariant === 'queued' && isExpired && timeLeft?.endTime;
  
//   const showStatusTimer = !isGeneral && timeInStatus && 
//                          (cardVariant === 'in-progress' || cardVariant === 'queued');
// // Логування для перевірки появи кнопки "?"
// console.log('TaskCard перевірка:', {
//   taskName,
//   isGeneral,
//   isAskHelp: isAskHelpTask(taskLink, receivedAt),
//   shouldShowAskHelpButton: !isGeneral && !isAskHelpTask(taskLink, receivedAt),
//   taskStatus,
//   taskLink
// });
//   return (
//     <div className={`task-card ${isBlocker ? 'blocker' : ''} ${isGeneral ? 'general' : 'personal'} ${cardVariant} ${isExpired ? 'expired' : ''} ${isNoHelp ? 'no-help' : ''} ${isAskHelp ? 'ask-help' : ''} ${isKpiHidden ? 'kpi-hidden' : ''} ${hasMentor ? 'has-mentor' : ''}`}>
//       {showGeneralTimer && (
//         <div className="task-progress" style={{
//           width: timeLeft ? `${timeLeft.percentage}%` : '0%',
//           left: '0',
//           right: 'auto'
//         }}></div>
//       )}
      
//       {showGeneralPoolTimer && (
//         <div className="task-progress general-pool-time" style={{
//           width: '100%',
//           left: '0',
//           right: 'auto',
//           backgroundColor: '#ff6b6b' 
//         }}></div>
//       )}
      
//       {showPersonalTimer && (
//         <div className="task-progress" style={{
//           width: timeLeft ? `${isReversed ? 100 - timeLeft.percentage : timeLeft.percentage}%` : '0%',
//           left: isReversed ? '0' : 'auto',
//           right: isReversed ? 'auto' : '0'
//         }}></div>
//       )}
      
//       <div className="task-content">
//         {!isGeneral && cardVariant === 'queued' && timeLeft && !isExpired && (
//           <button 
//             className="reverse-timer-btn"
//             onClick={() => toggleTimerDirection(taskLink)}
//             aria-label="Змінити напрямок таймера"
//           >
//             ↻
//           </button>
//         )}
        
//         {shouldShowNoHelpButton && (
//           <button 
//             className={`no-help-btn ${isNoHelpButtonActive ? 'active' : ''} ${isNoHelp ? 'marked' : ''}`}
//             onClick={() => isNoHelpButtonActive && handleNoHelpClick(task)}
//             disabled={!isNoHelpButtonActive || isNoHelp}
//             title={isNoHelp ? 'Ви вже позначили цю задачу в поточній сесії' : (isNoHelpButtonActive ? 'Позначити що допомога не потрібна' : 'Кнопка активна з 15 по 25 хвилину')}
//           >
//             {isNoHelp ? '✓' : '✗'}
//           </button>
//         )}

//         {/* Кнопка "?" - завжди однаковий вигляд, але логіка враховує відмову ментора */}
//         {shouldShowAskHelpButton && (
//           <button 
//             className="ask-help-btn"
//             onClick={() => handleAskHelpClick(task)}
//             title={isAskHelp ? 'Скасувати запит на допомогу' : 'Запитати допомогу'}
//           >
//             ?
//           </button>
//         )}
        
//         {showGeneralTimer && (
//           <div className="task-timer">{timeLeft.text}</div>
//         )}
        
//         {showGeneralPoolTimer && (
//           <div className="task-timer general-pool-timer">{generalPoolTime.text}</div>
//         )}
        
//         {showPersonalTimer && (
//           <div className="task-timer">{timeLeft.text}</div>
//         )}
        
//         {showStatusTimer && (
//           <div className="task-timer status-timer">{timeInStatus.text}</div>
//         )}
        
//         {showExpiredTime && (
//           <div className="task-expired-time expired-timer">{formatEndTime(timeLeft.endTime)}</div>
//         )}
        
//         {isGeneral && startdate && (
//           <div className="task-startdate">{formatStartDate(startdate)}</div>
//         )}
        
//         <div className="task-info">
//           <div className="task-name">{taskName}</div>
//         </div>
        
//         <div className="task-actions">
//           <a 
//             href={taskLink} 
//             target="_blank" 
//             rel="noopener noreferrer" 
//             className="task-link-btn"
//           >
//             →
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// };

//   // ПОКАЗУЄМО ЗАВАНТАЖЕННЯ ТІЛЬКИ ПІД ЧАС ПЕРШОГО ЗАВАНТАЖЕННЯ
//   if (loading && !initialLoadComplete) {
//     return <div className={`tasks-page ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`}><div className="loading">Завантаження...</div></div>;
//   }

//   if (error && !initialLoadComplete) {
//     return <div className={`tasks-page ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`}><div className="error">{error}</div></div>;
//   }

//   const sortedPersonalPoolTasks = getSortedPersonalPoolTasks();

//   return (
//     <div className={`tasks-page ${theme === 'dark' ? 'dark-theme' : 'light-theme'}`}>
//       {showNotification && notificationTask && (
//         <div className="notification-overlay">
//           <div className="notification-popup">
//             <div className="notification-content">
//               <div className="notification-header">
//                 <span className="notification-icon">⏰</span>
//                 <span className="notification-title">Увага!</span>
//                 <button className="notification-close" onClick={handleCloseNotification}>×</button>
//               </div>
//               <div className="notification-body">
//                 <p>Тебе смикне ментор по задачі:</p>
//                 <p className="notification-task-name">{notificationTask.TaskName || notificationTask.taskName}</p>
//                 <p className="notification-time">Через 5 хвилин</p>
//               </div>
//               <div className="notification-actions">
//                 <button className="notification-btn ok" onClick={handleCloseNotification}>OK</button>
//                 <button className="notification-btn no-help" onClick={handleNotificationNoHelp}>
//                   Допомога не потрібна
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {showInfoNotification && infoNotificationTask && (
//         <div className="notification-overlay">
//           <div className="notification-popup info-popup">
//             <div className="notification-content">
//               <div className="notification-header">
//                 <button className="notification-close" onClick={handleCloseInfoNotification}>×</button>
//               </div>
//               <div className="notification-body">
//                 <p className="notification-warning-text">За 15хв до задачі примусово буде долучений ментор</p>
//                 <p className="notification-instruction-text">Якщо не встигаєш виконати - підготуй деталі по задачі:</p>
//                 <ul className="notification-details-list">
//                   <li>- що зробив</li>
//                   <li>- де завтик</li>
//                   <li>- з чим допомогти</li>
//                 </ul>
//                 <p className="notification-task-name"><strong>Задача:</strong> {infoNotificationTask.TaskName || infoNotificationTask.taskName}</p>
//               </div>
//               <div className="notification-actions">
//                 <button className="notification-btn info-ok" onClick={handleCloseInfoNotification}>
//                   OK
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className="pool-section pip-target-element">
//         <div className="pool-header">
//           <div className="pool-header-left">
//             <div className="pool-title-m">
//               Загальний пул
//               <span className="task-count-m">({generalPoolTasks.length})</span>
//             </div>
//           </div>
//           <button 
//             className="collapse-btn"
//             onClick={() => setIsGeneralPoolCollapsed(!isGeneralPoolCollapsed)}
//             aria-label={isGeneralPoolCollapsed ? "Розгорнути" : "Згорнути"}
//           >
//             {isGeneralPoolCollapsed ? '▼' : '▲'}
//           </button>
//         </div>
        
//         {!isGeneralPoolCollapsed && (
//           <div className="tasks-list">
//             {generalPoolTasks.length === 0 ? (
//               <div className="no-tasks">Немає завдань у загальному пулі</div>
//             ) : (
//               generalPoolTasks.map(task => (
//                 <TaskCard key={`${task.TaskLink || task.taskLink}_${task.receivedAt}`} task={task} isGeneral={true} />
//               ))
//             )}
//           </div>
//         )}
//       </div>

//       <div className="pool-section pip-target-element">
//         <div className="pool-header">
//           <div className="pool-header-left">
//             <div className="pool-title-m">
//               Особистий пул
//               <span className="task-count-m">({sortedPersonalPoolTasks.length})</span>
//             </div>
//           </div>
//           <button 
//             className="collapse-btn"
//             onClick={() => setIsPersonalPoolCollapsed(!isPersonalPoolCollapsed)}
//             aria-label={isPersonalPoolCollapsed ? "Розгорнути" : "Згорнути"}
//           >
//             {isPersonalPoolCollapsed ? '▼' : '▲'}
//           </button>
//         </div>
        
//         {!isPersonalPoolCollapsed && (
//           <div className="tasks-list">
//             {sortedPersonalPoolTasks.length === 0 ? (
//               <div className="no-tasks">Немає завдань в особистому пулі</div>
//             ) : (
//               sortedPersonalPoolTasks.map(task => (
//                 <TaskCard key={`${task.TaskLink || task.taskLink}_${task.receivedAt}`} task={task} isGeneral={false} />
//               ))
//             )}
//           </div>
//         )}
//       </div>

//       <div className="pool-section pip-target-element">
//   <div className="pool-header">
//     <div className="pool-header-left">
//       <div className="pool-title-m">
//         Задачі з запитом про допомогу
//         <span className="task-count-m">({askHelpPoolTasks.length})</span>
//       </div>
//     </div>
//     <button 
//       className="collapse-btn"
//       onClick={() => setIsAskHelpPoolCollapsed(!isAskHelpPoolCollapsed)}
//     >
//       {isAskHelpPoolCollapsed ? '▼' : '▲'}
//     </button>
//   </div>
  
//   {!isAskHelpPoolCollapsed && (
//     <div className="tasks-list">
//       {askHelpPoolTasks.length === 0 ? (
//         <div className="no-tasks">Немає задач з запитом про допомогу</div>
//       ) : (
//         askHelpPoolTasks.map(task => (
//           <AskHelpTaskCard key={task.sessionId} taskData={task} />
//         ))
//       )}
//     </div>
//   )}
// </div>
//       <button className="pip-toggle-btn" onClick={handlePipToggle}>
//         📌 PiP Mode
//       </button>
//     </div>
//   );
// }

// export default TasksPage;